import React, { Component } from "react";
import PropTypes from "prop-types";
import apiProxy from "../../api/apiProxy.js";

const AlertCommentFormWrapper = WrappedComponent => {
  return class extends Component {
    createAlertComment = (content, onComplete) => {
      apiProxy.alertComment
        .createAlertComment(this.props.alertId, content)
        .then(onComplete)
        .catch(response => {
          this.props.onError(response);
        });
    };

    render() {
      return (
        <WrappedComponent
          createAlertComment={this.createAlertComment}
          {...this.props}
        />
      );
    }
  };
};

AlertCommentFormWrapper.propTypes = {
  alertId: PropTypes.string.isRequired
};

export default AlertCommentFormWrapper;
